// ─── Catégories d'événement (portées de MoPCal) ──────────────────
// Liste FIXE. Les mêmes ids que MoPCal → les docs d'événements restent
// compatibles (champ `categorie` = id, ou '' pour « aucune »). L'emoji est le
// 1er mot du label ; la catégorie ne sert qu'à l'ÉTIQUETTE (emoji) et au FILTRE
// — la couleur d'un événement vient du CALENDRIER, jamais de la catégorie.
// i18n : chaque entrée porte une clé `i18n` stable ; le champ `label` (fr) reste
// le repli quand aucune fonction de traduction `t` n'est fournie au point d'affichage.
export const CATEGORIES_EVT = [
  { id: 'sport',        emoji: '🏃',    i18n: 'evenements.catSport',        label: '🏃 Sport' },
  { id: 'sante',        emoji: '🏥',    i18n: 'evenements.catSante',        label: '🏥 Santé' },
  { id: 'ecole',        emoji: '🏫',    i18n: 'evenements.catEcole',        label: '🏫 École' },
  { id: 'anniversaire', emoji: '🎂',    i18n: 'evenements.catAnniversaire', label: '🎂 Anniversaire' },
  { id: 'vacances',     emoji: '🏖️',    i18n: 'evenements.catVacances',     label: '🏖️ Vacances' },
  { id: 'famille',      emoji: '👨‍👩‍👧', i18n: 'evenements.catFamille',      label: '👨‍👩‍👧 Famille' },
  { id: 'activite',     emoji: '🎨',    i18n: 'evenements.catActivite',     label: '🎨 Activité' },
  { id: 'rdv',          emoji: '📅',    i18n: 'evenements.catRdv',          label: '📅 Rendez-vous' },
  { id: 'repas',        emoji: '🍲',    i18n: 'evenements.catRepas',        label: '🍲 Repas' },
  { id: 'autre',        emoji: '📌',    i18n: 'evenements.catAutre',        label: '📌 Autre' },
];

// ── TYPES d'événement (comme MoPCal) ──────────────────────────────
// Champ `type` STOCKÉ sur l'événement : 'simple' (créé à la main),
// 'recurrent' (généré par une récurrence), et — à venir — 'repas'
// (menus du module Repas) et 'edt' (emploi du temps).
export const TYPES_EVENEMENT = [
  { id: 'simple',    emoji: '📌', i18n: 'evenements.typeSimple',    label: '📌 Simple' },
  { id: 'recurrent', emoji: '🔁', i18n: 'evenements.typeRecurrent', label: '🔁 Récurrent' },
  { id: 'repas',     emoji: '🍽️', i18n: 'evenements.typeRepas',     label: '🍽️ Repas' },
  { id: 'edt',       emoji: '📚', i18n: 'evenements.typeEdt',       label: '📚 Emploi du temps' },
];

// Type EFFECTIF d'un événement : champ `type` s'il est valide, sinon dérivé
// (rétro-compat : les anciens docs n'ont pas le champ).
export function typeEvenement(ev) {
  if (ev?.type && TYPES_EVENEMENT.some(x => x.id === ev.type)) return ev.type;
  return ev?.isRecurrent ? 'recurrent' : 'simple';
}

export function labelTypeEvenement(id, t) {
  const x = TYPES_EVENEMENT.find(x => x.id === id);
  if (!x) return id || '';
  return (t && x.i18n) ? `${x.emoji} ${t(x.i18n)}` : x.label;
}

// Filtres par TYPE (jetons 'type:<id>' dans le Set des masqués).
export const TYPE_FILTRES = TYPES_EVENEMENT.map(x => ({ ...x, id: `type:${x.id}` }));

export const emojiCategorie = (id) => {
  const c = CATEGORIES_EVT.find(c => c.id === id);
  if (!c) return '';
  return c.emoji || (c.label || '').split(' ')[0] || '';
};

// Libellé d'une catégorie. Passe `t` (useT) au point d'affichage pour traduire ;
// sinon on retombe sur le label fr embarqué. L'emoji n'est jamais traduit.
export const labelCategorie = (id, t) => {
  const c = CATEGORIES_EVT.find(c => c.id === id);
  if (!c) return id || '';
  if (t && c.i18n) {
    const emoji = c.emoji || (c.label || '').split(' ')[0] || '';
    return emoji ? `${emoji} ${t(c.i18n)}` : t(c.i18n);
  }
  return c.label || id || '';
};

// Libellé d'un filtre de TYPE (même contrat : `t` optionnel, repli fr).
export const labelTypeFiltre = (id, t) => {
  const f = TYPE_FILTRES.find(f => f.id === id);
  if (!f) return id || '';
  if (t && f.i18n) {
    const emoji = f.emoji || (f.label || '').split(' ')[0] || '';
    return emoji ? `${emoji} ${t(f.i18n)}` : t(f.i18n);
  }
  return f.label || id || '';
};

// Événement MASQUÉ si sa catégorie est dans le Set, OU si son jeton de type l'est.
export function estMasqueEvenement(ev, masquees) {
  if (!masquees || !masquees.size || !ev) return false;
  if (ev.categorie && masquees.has(ev.categorie)) return true;
  const ty = typeEvenement(ev);
  // 'type:autre' = ancien jeton des « ponctuels » (compat filtres en mémoire).
  return masquees.has(`type:${ty}`) || (ty === 'simple' && masquees.has('type:autre'));
}
